export const RESULT_CODE = Object.freeze({
  SUCCESS: '00101', //成功
  NOT_FRIEND: '00102', //友だちではない
  NOT_EXIST: '00104', //存在しない
  OTHER: '00105', //その他のエラー
  NOT_LOGGED_IN: '00106', //ログインしていない
  DATABASE_ERROR: '00107', //データベースエラー
  OFF_HOUR: '00108', //キャンペーンが実施期間外
  ALREADY_ENTRIED: '00109', //既に参加済み
  BLOCKED: '00110', //ブロック状態
  TWITTER_ACCOUNT_DUPULICATE: '00111', //twitter アカウントが既に使われている
  INVALID_CALLBACK_PARAMETER: '00112', //不正なコールバックパラメータ
  INVALID_STATE_PARAMETER: '00113', // 不正なstateパラメータ
  INVALID_API_KEY: '00114', // 不正なAPIキーでリクエスト
  PROGRAM_FUNCTION_FAILURE: '00115', // CRMマイレージAPIから失敗が返却された
  DISABLED_RECEIPT_AI: '00116', // レシートAIのシステム連携が設定されていない
  DISABLED_CRM_MILEAGE: '00117', // CRMマイレージのシステム連携が設定されていない
  CHECKIN_ERROR: '00118', // チェックインのシステム連携エラー
  INVALID_FIRST_ANSWERED_SURVEY: '00119', // 初回参加でアンケート回答がない
  DUPLICATED_FIRST_ANSWERED_SURVEY: '00120', // アンケート回答が重複
  SURVEY_EMPTY_REQUIRED_FIELD: '00121', // アンケートの必須項目に回答していない
  SURVEY_EMPTY_ANSWER: '00122', // アンケート回答が空オブジェクト
});

export const RECEIPT_RESULT_CODE = Object.freeze({
  SUCCESS: '00101', //成功
  SYSTEM_ERROR: '00102', //システムエラー
  INVALID_PARAMETERS: '00103', //パラメータが不正
  NOT_EXIST: '00104', //リソースが存在しない
  RUNNING: '00105', //解析中
});
